import type { CallTile } from "./context";
import { isContentAttendee, isRemoteAttendee } from "./first-remote-presence";

export interface CallParticipant {
  attendeeId: string;
  name: string;
  isLocal: boolean;
}

export interface ParticipantWithVideo extends CallParticipant {
  video: CallTile | undefined;
}

export function updateRoster(
  roster: ReadonlyMap<string, CallParticipant>,
  event: { attendeeId: string; present: boolean; name: string },
  ownAttendeeId: string | undefined,
): ReadonlyMap<string, CallParticipant> {
  const next = new Map(roster);
  if (!event.present || isContentAttendee(event.attendeeId)) {
    next.delete(event.attendeeId);
    return next;
  }
  next.set(event.attendeeId, {
    attendeeId: event.attendeeId,
    name: event.name,
    isLocal: !isRemoteAttendee(event.attendeeId, ownAttendeeId),
  });
  return next;
}

export function participantsWithVideo(
  roster: ReadonlyMap<string, CallParticipant>,
  tiles: readonly CallTile[],
  cameraOn: boolean,
): ParticipantWithVideo[] {
  return Array.from(roster.values(), (participant) => ({
    ...participant,
    // Stopping local video leaves a bound tile behind; remote removals do not.
    video:
      participant.isLocal && !cameraOn
        ? undefined
        : tiles.find((tile) => !tile.isContent && tile.attendeeId === participant.attendeeId),
  }));
}
